import React from "react";
import { Outlet } from "react-router-dom";
import './myapp.scss'

export default function Myapp() {
  return (
    <div className="main-content myapp">
      <Outlet />
    </div>
  );
}